import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import {
  getDepositPlansRequest,
  getDepositPlansSuccess,
  getDepositPlansFailure,
  subscribeDepositPlanRequest,
  subscribeDepositPlanSuccess,
  subscribeDepositPlanFailure,
  getSubscribedPlansRequest,
  getSubscribedPlansSuccess,
  getSubscribedPlansFailure,
  depositPlanBreakRequest,
  depositPlanBreakSuccess,
  depositPlanBreakFailure,
} from "./depositeSlice";

function* fetchDepositPlans() {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/getdepositplanmobile`,
        {}
      )
    );

    if (response.data.success) {
      yield put(getDepositPlansSuccess(response.data));
    } else {
      yield put(getDepositPlansFailure(response.data.message));
      toast.error(response.data.message || "No deposit plans found");
    }
  } catch (error) {
    yield put(
      getDepositPlansFailure(error.response?.data?.message || error.message)
    );
    toast.error("Error fetching deposit plans");
  }
}

function* subscribeDepositPlan(action) {
  try {
    const token = localStorage.getItem("token");

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/subscribedepositplan`,
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success) {
      yield put(subscribeDepositPlanSuccess(response.data));
      toast.success(response.data.message);
    } else {
      yield put(subscribeDepositPlanFailure(response.data.message));
      toast.error(response.data.message || "Failed to subscribe deposit plan");
    }
  } catch (error) {
    yield put(
      subscribeDepositPlanFailure(
        error.response?.data?.message || error.message
      )
    );
    toast.error(
      error.response?.data?.message || "Error subscribing deposit plan"
    );
  }
}

function* fetchSubscribedPlans() {
  try {
    const token = localStorage.getItem("token");

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/getsubscribedplanmobile`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.success) {
      yield put(getSubscribedPlansSuccess(response.data));
    } else {
      yield put(getSubscribedPlansFailure(response.data.message));
      toast.info(response.data.message || "No subscribed plans found");
    }
  } catch (error) {
    yield put(
      getSubscribedPlansFailure(error.response?.data?.message || error.message)
    );
    toast.error("Error fetching subscribed plans");
  }
}

function* depositPlanBreak(action) {
  try {
    const token = localStorage.getItem("token");

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion-deposit/depositplanbreak`,
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success) {
      yield put(depositPlanBreakSuccess(response.data));
      toast.success(response.data.message);
    } else {
      yield put(depositPlanBreakFailure(response.data.message));
      toast.error(response.data.message || "Failed to break deposit plan");
    }
  } catch (error) {
    yield put(
      depositPlanBreakFailure(error.response?.data?.message || error.message)
    );
    toast.error(error.response?.data?.message || "Error breaking deposit plan");
  }
}

export function* depositSaga() {
  yield takeLatest(getDepositPlansRequest.type, fetchDepositPlans);
  yield takeLatest(subscribeDepositPlanRequest.type, subscribeDepositPlan);
  yield takeLatest(getSubscribedPlansRequest.type, fetchSubscribedPlans);
  yield takeLatest(depositPlanBreakRequest.type, depositPlanBreak);
}
